let dirPath = 'static/games/page024_game1';
let dirAudio = 'games/page024_game1/audio/';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  bruteForce: false,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: { shuffle: true },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'left',
        idItem: 'con1',
        items: [{ idGroup: 'right', idItem: 'con1', correct: [{ idGroup: 'left', idItem: 'con1' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con2',
        items: [{ idGroup: 'right', idItem: 'con2', correct: [{ idGroup: 'left', idItem: 'con2' }] }],
      },
      {
        idGroup: 'left',
        idItem: 'con3',
        items: [{ idGroup: 'right', idItem: 'con3', correct: [{ idGroup: 'left', idItem: 'con3' }] }],
      },
    ],
  },
  layout: {
    itemsConfig: {
      background: {
        background: { color: ['transparent'] },
      },
    },
    otherProperty: {
      lines: {
        good: {
          hideLine: true,
        },
        connect: {
          color: '#000000',
          hideLine: true,
        },
        select: {
          color: '#000000',
          hideLine: true,
        },
      },
      points: {
        pointMouse: {
          color: 'rgba(0,0,0,0.3)',
          rad: 0,
          alwaysShow: true,
        },
        itemsConfig: {
          alwaysShow: true,
          color: 'transparent',
          positions: { rad: 15 },
        },
      },
    },
    groups: [
      {
        idGroup: 'left',
        positions: { autoFit: true, type: 'absolute', pos: { x: 300, y: 0 } },
        itemsConfig: {
          positions: { pos: { width: 288, height: 265 }, columns: 1 },
        },
        otherProperty: {
          points: {
            itemsConfig: { image: { src: dirPath + '/img/0p.png' }, registrationPoint: { setTo: 'right' } },
            items: [{ id: 'p01', positions: { pos: { setTo: 'right' } } }],
          },
        },
        items: [
          { id: 'con1', background: { image: { src: dirPath + '/img/00.png' } } },
          { id: 'con2', background: { image: { src: dirPath + '/img/01.png' } } },
          { id: 'con3', background: { image: { src: dirPath + '/img/02.png' } } },
        ],
      },
      {
        idGroup: 'right',
        positions: { autoFit: true, type: 'absolute', pos: { x: 1100, y: 0 } },
        itemsConfig: {
          positions: { pos: { width: 589, height: 265 }, columns: 1 },
          background: { image: { pos: { x: 42 } } },
        },
        otherProperty: {
          lines: {
            good: {
              hideLine: true,
            },
            connect: {
              color: '#000000',
              hideLine: true,
            },
            select: {
              color: '#000000',
              hideLine: true,
            },
          },
          points: {
            itemsConfig: {
              image: { src: dirPath + '/img/1p.png' },
              registrationPoint: { setTo: 'left' },
            },
            items: [{ id: 'p01', positions: { pos: { setTo: 'left' }, offset: { x: 21 } } }],
          },
        },
        items: [
          {
            id: 'con1',
            background: { image: { src: dirPath + '/img/10.png' } },
            otherProperty: { audio: 'a01' },
          },
          {
            id: 'con2',
            background: { image: { src: dirPath + '/img/11.png' } },
            otherProperty: { audio: 'a02' },
          },
          {
            id: 'con3',
            background: { image: { src: dirPath + '/img/12.png' } },
            otherProperty: { audio: 'a03' },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'connect',
  realHeight: 800,
  realWidth: 1800,
  mainImage: {
    imagePath: 'informatyka/games/page024_game1/img/24_ćw1.png',
    pos: {
      x: 0,
      y: 0,
    },
    width: 1920,
    height: 1080,
  },
  mbAudioItemData: [
    {
      id: 'a01',
      src: dirAudio + 'z24c1-1.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 265,
        x: 141,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a02',
      src: dirAudio + 'z24c1-3.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 265,
        x: 141,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
    {
      id: 'a03',
      src: dirAudio + 'z24c1-2.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        fill: 'black',
      },
      pos: {
        y: 265,
        x: 141,
      },
      width: '57px',
      height: '57px',
      unit: 'px',
    },
  ],
  cssStyle: {
    overflow: 'hidden',
  },
  configGame: configGame,
};

export default dataConfig;
